export const PROMO_TOOLTIP_BUTTON_TEXT = 'Подробнее';
